import { event, GtagEvent } from "./event";

export interface SpendVirtualCurrency extends GtagEvent {
    value:number;
    virtual_currency_name:string;
    item_name?:string;
}
export const spend_virtual_currency = ($_:SpendVirtualCurrency) => event('spend_virtual_currency',$_);